import { NullDataHandlerService } from 'src/app/modules/core/services/null-data-handler.service';
import { UserViewModel } from 'src/app/models/users/user-view.model';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/user.service";
import * as i2 from "@angular/router";
export class UserDetailsResolverService extends NullDataHandlerService {
    constructor(userService, router) {
        super(router);
        this.userService = userService;
        this.router = router;
    }
    resolve(route, state) {
        let id = route.paramMap.get('id') || '';
        if (id == 'new')
            return new UserViewModel();
        return this.userService.getById(id).then((response) => {
            if (!response)
                this.redirectToNotFound();
            else
                return response;
        });
    }
}
UserDetailsResolverService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserDetailsResolverService_Factory() { return new UserDetailsResolverService(i0.ɵɵinject(i1.UserService), i0.ɵɵinject(i2.Router)); }, token: UserDetailsResolverService, providedIn: "root" });
